export default __webpack_public_path__ + "static/media/output.1ad6e604.webm";